import React from "react";

const Footer = () => {
  return (
    <div id="socials" className="footer_container">
      <section>
        <div class="max-w-screen-xl px-4 py-12 mx-auto space-y-8 overflow-hidden sm:px-6 lg:px-8">
          <div className="footer_logo">
            <img src="/images/logo.jpg" alt="Logo" />
          </div>
          <div class="flex justify-center mt-8 space-x-6">
            <a
              href="https://x.com/koonofficial"
              target="_blank"
              class="hover:text-gray-500"
            >
              <span class="sr-only">Twitter</span>
              <svg
                class="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"></path>
              </svg>
            </a>

            <a
              href="https://t.me/+up4v1c1H0fdiMjE0"
              target="_blank"
              class=" hover:text-gray-500"
            >
              <span class="sr-only">Telegram</span>
              <svg
                class="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.67 7.18L15.04 17.8c-.12.51-.43.63-.87.39l-2.42-1.78-1.17 1.12c-.12.12-.22.23-.46.23l.16-2.31 4.21-3.79c.18-.15-.04-.24-.28-.09l-5.2 3.27-2.23-.7c-.49-.15-.5-.49.1-.73l8.68-3.36c.4-.15.77.09.64.72z"></path>
              </svg>
            </a>

            <a
              href="https://discord.com"
              target="_blank"
              class="hover:text-gray-500"
            >
              <span class="sr-only">Discord</span>
              <svg
                class="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3706-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.119.099.2449.1981.3707.2924a.077.077 0 01-.0066.1276c-.598.3428-1.2195.6447-1.8723.8923a.0766.0766 0 00-.0406.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5218 6.0023-3.0294a.077.077 0 00.0312-.0552c.5003-5.177-1.0487-9.657-4.5495-13.6608a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.955-2.4189 2.157-2.4189 1.2108 0 2.1852 1.0857 2.1569 2.4189 0 1.3333-.9551 2.419-2.157 2.419zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.955-2.4189 2.1569-2.4189 1.2108 0 2.1852 1.0857 2.1569 2.4189 0 1.3333-.9461 2.419-2.1569 2.419z"></path>
              </svg>
            </a>
          </div>

          <p class="mt-8 text-base leading-6 text-center">
            2024 KOON. All Rights Reserved.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Footer;
